import React, { Component, useState, useEffect } from 'react';
import $ from 'jquery'; 
import axios from "axios";
import { Cookies } from 'react-cookie';
import jsonp from 'jsonp';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

//axios.defaults.withCredentials = true;

const cookies = new Cookies(); 

export const setCookie = (name, value) => {
  const now = new Date();
  return cookies.set(name, value, { path: '/', expires: new Date(new Date().setHours(23, 59, 59, 999)) });
}

export const setSearchCookie = (name, value) => {
  const tenYearsLater = new Date();
  tenYearsLater.setFullYear(tenYearsLater.getFullYear() + 10);

  return cookies.set(name, value, {
    path: '/',
    expires: tenYearsLater,
  });
};
export const LoadingSpinner = () => {
  return (
    <div className="loader_wrap02 state_add">
      <div className="loader_content">

        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

      </div>
    </div>
  );
}
export const getCookie = (name) => {
  return cookies.get(name);
}

export const deleteCookie = (name) => {
  document.cookie = name + '=; Max-Age=0; path=/';
}

// 쿠키 설정 함수
export const setCookieCross = (name, value, options = {}) => {
  let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.path) {
    cookieStr += `; path=${options.path}`;
  }

  if (options.expires instanceof Date) {
    cookieStr += `; expires=${options.expires.toUTCString()}`;
  }

  document.cookie = cookieStr;
}

// 쿠키 가져오기
export const getCookieCross = (name) => {
  const value = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${encodeURIComponent(name)}=`));
  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

// 주간 유효기간 계산 (다음 월요일 0시)
export const getNextMonday = () => {
  const now = new Date();
  const day = now.getDay(); // 0: Sunday, 1: Monday, ..., 6: Saturday
  const diffToMonday = (8 - day) % 7 || 7;
  const nextMonday = new Date(now);
  nextMonday.setDate(now.getDate() + diffToMonday);
  nextMonday.setHours(0, 0, 0, 0);
  return nextMonday;
}

// 단어 추가 함수
export const addToWordCookie = (word) => {
  const cookieName = 'wordList';
  const existing = getCookieCross(cookieName);
  const wordArr = existing ? existing.split(',') : [];

  if (!wordArr.includes(word)) {
    wordArr.push(word);
    const expires = getNextMonday();

    setCookieCross(cookieName, wordArr.join(','), {
      path: '/',
      expires
    });
  }
}

// 단어 추가 함수
export const addToSwordCookie = (word) => {
  const cookieName = 'swordList';
  const existing = getCookieCross(cookieName);
  const wordArr = existing ? existing.split(',') : [];

  if (!wordArr.includes(word)) {
    wordArr.push(word);
    const expires = getNextMonday();

    setCookieCross(cookieName, wordArr.join(','), {
      path: '/',
      expires
    });
  }
}

export function loadExternalScript(src, callback) {
  // 이미 추가된 경우 중복 로딩 방지
  if (document.querySelector(`script[src="${src}"]`)) {
    if (callback) callback();
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  script.async = true;

  script.onload = () => {
    if (callback) callback();
  };

  script.onerror = () => {
    console.error(`스크립트 로딩 실패: ${src}`);
  };

  document.body.appendChild(script);
}
//
export const CommonScriptLoader = ({ src, onLoadCallback }) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${src}"]`)) {
      onLoadCallback?.();
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => {
      onLoadCallback?.();
    };
    document.body.appendChild(script);
  }, [src, onLoadCallback]);

  return null;
};

export const setAutoCookie = (value) => {
  const now = new Date();
  return cookies.set('pocketAuto', value, { path: '/', expires: new Date(Date.now() + 20 * 365 * 24 * 60 * 60 * 1000) });
}

export async function login_check() {
  const publicUrl = process.env.PUBLIC_URL;

  try {
    const res = await axios.get(publicUrl + '/api/getLoginCheck.php');
    return res.data.login;     // true / false
  } catch (e) {
    console.error(e);
    return false;
  }      
}
 
export default function AKACollectLoader() {
  const location = useLocation();

  useEffect(() => {
    // 기존 스크립트 제거
    const oldScript = document.getElementById("aka-collect");
    if (oldScript) { 
      oldScript.remove();
    }
    //console.log('load aka script');
    // 새 스크립트 생성
    const script = document.createElement("script");
    script.id = "aka-collect";
    script.src = `https://aka.asiae.co.kr/scripts/AKACollect.js?u=${Date.now()}`;
    script.async = true;

    document.body.appendChild(script);

    // cleanup (선택)
    return () => {
      const current = document.getElementById("aka-collect");
      if (current) current.remove();
    };
  }, [location.pathname]); // ✅ 페이지 이동 감지

  return null; // 화면에 아무것도 렌더링하지 않음
}

export const LocationWrapper = ({ children }) => {
  const location = useLocation();
  return children(location);
};

export const withRouter = (Component) => {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    return (
      <Component
        {...props}
        params={params}
        location={location}
        navigate={navigate}
      />
    );
  };
};
export function withNavigation(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}
function uinfo(json) {
  console.log(json);
}

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // iOS 대응을 위해 requestAnimationFrame 사용
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
}
//
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const checkLogin = getCookie('check_login');
export const isLogin = getCookie('islogin');
export const loginUrl = process.env.REACT_APP_LOGIN_URL;
export const pocketUrl = 'https://pocket.asiae.co.kr';
